import { takeLatest } from 'redux-saga/effects';

import {
  ON_PAYMENT_PLAN_MOUNT,
  ON_PAYMENT_PLAN_MOUNT_ERROR,
  PAY_INSTALLMENT,
  PAY_INSTALLMENTS
} from '../actions';

import {
  fetchPaymentPlanData,
  payInstallment,
  payAllInstallments
} from './sagas';

import { redirectToHomepage } from '../../dashboard/actions/sagas';


// Watchers
export function* onPaymentPlanInit() {
  yield takeLatest(ON_PAYMENT_PLAN_MOUNT, fetchPaymentPlanData);
}

export function* redirectToHomepageOnPaymentPlansMountError() {
  yield takeLatest(ON_PAYMENT_PLAN_MOUNT_ERROR, redirectToHomepage);
}

export function* onPaymentInstallment() {
  yield takeLatest(PAY_INSTALLMENT, payInstallment);
}

export function* onPayAllInstallment() {
  yield takeLatest(PAY_INSTALLMENTS, payAllInstallments);
}





// WEBPACK FOOTER //
// ./src/modules/payment-plans/actions/watchers.js